import React, { useEffect, useState } from "react";
import Ki from "../../components/spravochniki/ki/Ki";
import Modal from "../../components/UI/Modal";

function Page(props) {
  const [openingModal, setOpeningModal] = useState(false);

  useEffect(() => {
    setOpeningModal(true);
  }, []);
  
  return (
    <>
      <Modal
        fullwidth={"45%"}
        isOpen={openingModal}
        onClose={() => setOpeningModal(false)}
      >
        <Ki onClose={() => setOpeningModal(false)} />
      </Modal>
    </>
  );
}

export default Page;
